import { useEffect } from "react";
import { setTitle } from "@store/title-store";

import { Profile } from "@feature/profile";

export const ProfilePage: React.FC = () => {
  useEffect(() => {
    setTitle([
      { title: "Главная", href: "/" },
      { title: "Личный кабинет", href: "/profile" },
    ]);
  }, []);

  return (
    <main className="content-container">
      <div className="content-section">
        <Profile />
      </div>
    </main>
  );
};
